export default __webpack_public_path__ + "static/media/cp_geo_sx.2175354a.svg";